"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dd791 = void 0;
const dd791_schema_1 = require("./dd791.schema");
const official_form_base_model_1 = require("../official-form-base-model");
class Dd791 extends official_form_base_model_1.OfficialFormBaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {
            issuesDataRows: [],
        };
    }
    getSchema() {
        return dd791_schema_1.dd791Schema;
    }
}
exports.Dd791 = Dd791;
